export const SUBMIT_CHECKOUT_SUCCESS = 'SUBMIT_CHECKOUT_SUCCESS';
export const SUBMIT_CHECKOUT_FAILURE = 'SUBMIT_CHECKOUT_FAILURE';
export const ADD_APPOINTMENT_DATA_FAILURE = 'ADD_APPOINTMENT_DATA_FAILURE';
export const ADD_APPOINTMENT_DATA_SUCCESS = 'ADD_APPOINTMENT_DATA_SUCCESS';
export const UPLOAD_TECHNICAL_CARD_PICTURE_ERROR = 'UPLOAD_TECHNICAL_CARD_PICTURE_ERROR';



// WEBPACK FOOTER //
// ./src/workflow/checkout/clientRegistration/types.js